export default __webpack_public_path__ + "static/media/menu25.a05bc5f0.svg";